module.exports = __webpack_public_path__ + "static/img/consult_black.9d92ba79.svg";